// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__9P9lD","content":"LayoutSettings_content__mpD4i"};